import React from "react";
import HighlightBlock from "./HighlightBlock";

export default function LocationDistances({ locationSrc, points = [], highlightBlockProps = {} }) {
    return (
        <section className="location-distances py-3 h-100">
            <div className="container">
                <HighlightBlock {...highlightBlockProps}>
                    <h2 className="section-title">Konum & Mesafeler</h2>

                    <div className="row align-items-stretch">
                        <div className="col-12 col-md-6 d-flex flex-column justify-content-start">
                            <ul className="list-unstyled location-distances__list mb-4">
                                {points.map((pt, i) => (
                                    <li key={i} className="location-distances__item">
                                        <span className="location-distances__name">{pt.name}</span>
                                        <span className="location-distances__distance">{pt.distance}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-12 col-md-6 d-flex align-items-center">
                            <div className="location-distances__map w-100">
                                <iframe
                                    title="Konum"
                                    src={locationSrc}
                                    width="100%"
                                    height="95%"
                                    style={{ border: 0, borderRadius: "18px" }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </div>
                    </div>

                </HighlightBlock>
            </div>
        </section>
    );
}
